<template>
    <div class="xiangmu">
<!--        <breadcrumb :routerList="[{to:'/chanp/salesTableF',title:'销售样表（外）'}]"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="产品大类">
						    <brselect category="product_level" :v="q.oneLid" v-model="q.oneLid" :clearable="true"
						              style="width:100%;"/>
						</el-form-item>
						<el-form-item label="产品状态">
						    <brselect category="chainStatus" :v="q.chainStatus" v-model="q.chainStatus" :clearable="true"
						              style="width:100%;"/>
						</el-form-item>
						<el-form-item label="产品型号">
						    <el-input v-model="q.promodelLike" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品编码">
						    <el-input v-model="q.prodcodeLike" placeholder=""></el-input>
						</el-form-item>
					</div>
            <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="产地" prop="factory">
                    <brselect category="factory" :v="q.chandidata" :showcode="true"
                              v-model="q.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                  </el-form-item>
            </div>
                    <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" style="border:none;" @click="query">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
						<el-button
							class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
							@click="createdemand" v-auth="'xsyb_xinzeng_f'"
							>新增销售样表
						</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table @selection-change="handleSelectionChange"
                      ref="multipleTable"
                      :data="tableData"
                      :border="true"
                      style="width: 100%"
					  max-height="450"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.$index+1}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodseries"
                        label="产品大类"
                        min-width="100"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodseries}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="procategory"
                        label="二级分类"
						width="120"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.procategory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="promodel"
                        label="产品型号"
						min-width="160"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;" :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.promodel}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="userCode"
                        label="型号经理"
                        width="120"
						:show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.userCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodcode"
                        label="产品编码"
						width="120"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodcode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodstatus"
                        label="状态"
                        :show-overflow-tooltip="true"
                        width="70"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodstatus | dictname('prodstatus')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="chainStatus"
                        label="状态码"
						:show-overflow-tooltip="true"
                        width="120" >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.chainStatus}}|{{scope.row.chainStatus | dictname('chainStatus')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="protype"
                        label="型号属性"
						:show-overflow-tooltip="true"
                        width="90"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.protype}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="areaList"
                        label="区域"
						:show-overflow-tooltip="true"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
							<span v-for="(item,index) in scope.row.areaList"
							     :key="index"
							     :value="item"
							     :class="{'redclass':scope.row.seriestrue == 0}">
							    {{item | dictname('neibu_haiwai_area')}}
							</span>
						</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="factory"
                        label="产地"
                        width="60"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;" :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.factory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="validperiod"
                        label="有效期"
						:show-overflow-tooltip="true"
                        width="100"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{ scope.row.validperiod?scope.row.validperiod.substr(0,10):'' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="ldate"
                        label="更新时间"
						:show-overflow-tooltip="true"
                        width="160"
                >
                    <template slot-scope="scope">
                        <div class="tanboxs">
                            <span v-if="usertype==1" :class="{'redclass':scope.row.seriestrue == 0}">{{ scope.row.ldate}}</span>
                            <span @click="mousetable(scope.row)" v-if="usertype!=1"
                                  :class="{'redclass':scope.row.seriestrue == 0}">{{ scope.row.ldate}}</span>
                            <el-dialog
                                    title=""
                                    top="30vh"
                                    :visible.sync="dialogVisible"
                                    :fullscreen="false"
                                    width="35%"
                                    :modal="false"
                                    :before-close="handleClose">
                                <div class="tanBox">
                                    <el-table
                                            :data="tableDatas"
                                            style="width: 100%">
                                        <el-table-column
                                                prop="updatecode"
                                                label="更新人编号"
                                                width="130"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="updatename"
                                                label="更新人名称"
                                                width="190"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="updatetime"
                                                label="更新时间">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-dialog>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="180"
                        fixed="right"
                        v-auth="'xsyb_caozuo_f'"
                >
                    <template slot-scope="scope">
						<div style="text-align: left;">
							<el-button
							         type="text"
							         size="small"
							         class="h-tableLink h-btn" @click="below(scope.row)"
                                     v-if="scope.row.chainStatus == 'PA' ||scope.row.chainStatus == 'EM' "
							         v-auth="'xsyb_caozuo_f'"
							 >
                                订单终止
							 </el-button>
							 <!--<el-button
							         type="text"
							         size="small"
							         class="h-tableLink h-btn" @click="Listed(scope.row)"
							         v-if="scope.row.prodstatus != '1'"
							         v-auth="'xsyb_caozuo_f'"
							 >
							     上市
							 </el-button>-->
							 <el-button
							         type="text"
							         size="small"
							         class="h-tableLink h-btn" @click="toChange(scope.row)" v-auth="'xsyb_caozuo_f'">
							     修改
							 </el-button>
							 <el-button
							         type="text"
							         size="small"
							         class="h-tableLink h-btn" @click="toDelete(scope.row)" v-auth="'xsyb_caozuo_f'">
							     删除
							 </el-button>
						</div>
                       
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-ss" v-if="scope.row.prodstatus == '1'" title="下市" @click="below(scope.row)"></span>
							<span class="l-operationlist br-operation-xs" v-if="scope.row.prodstatus != '1'" title="上市" @click="Listed(scope.row)"></span>
							<span class="l-operationlist br-operation-xg" title="修改" @click="toChange(scope.row)"></span>
							<span class="l-operationlist br-operation-delete" title="删除" @click="toDelete(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                <div>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="exportExcel" v-auth="'xsyb_daochu_f'">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn" v-if="usertype!=1" v-auth="'xsyb_daoru_f'">批量导入
                    </el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="samplelistFImportExcel"
                                     :startrow="3" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2" style="display:inline-block">
                    <pagination :page="q" @query="query"/>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        name: "productManage",
        data() {
            return {
              /*  gly:false,*/
                //导入Excel
                uploaddownexcelflag: false,
                usertype: null,
                tableDatas: [],
                dialogVisible: false,
                isflags: false,
                //表单
                all: '全部',
                q: {
                    oneLid:null,
                    prodcodeLike:null,
                    promodelLike:null,
                    chainStatus:null,
                    channelList: [],
                    chandidata:null,
                    ids: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                tableData: [],
            }
        },
        created() {
            this.query();
            this.c = this._user.usertype;
        },
        methods: {
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //更新操作
            mousetable(value) {
                ss.salesListF.selectUpdate(value.id).then(rd => {
                    this.tableDatas = rd;
                    this.dialogVisible = true;
                })
            },
           //关闭弹出框
            handleClose(v) {
                v()
            },
            //重置检索项
            resetData() {
                this.q.oneLid = null;
                this.q.chainStatus = null;
                this.q.promodelLike = null;
                this.q.prodcodeLike = null;
               this.q.chandidata = null;
            },
            query() {
               // this.gly = this.$store.getters.hasRole("swyl_xsyb_gly_f,swyl_admin");
                this.usertype = this._user.usertype;
                ss.salesListF.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //订单终止
            below(value) {
                if (value.chainStatus == "订单终止") {
                    this.$message.error("产品已订单终止");
                } else {
                    this.$msg.confirm("确认订单终止?", () => {
                      if(value.chainStatus != 'EM'){
                        this.$message.error("非制造终止不能下市");
                        return null;
                      }else {
                        ss.salesListF.below(value.id).then(rd => {
                          this.$msg.msgs(rd.msg);
                          this.query();
                        });
                      }
                    });
                }
            },
            //上市
           /* Listed(value) {
                if (value.prodstatus == "上市") {
                    this.$message.error("产品已上市");
                } else {
                    this.$msg.confirm("确认上市?", () => {
                        ss.salesListF.Listed(value.id).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                }
            },*/
            //修改销售样表
            toChange(value) {
                this.$router.push({path: "/chanp/salesTableFbj", query: {id: value.id}});
            },
            //删除销售样表
            toDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.salesListF.toDelete(value.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    this.q.ids.push(element.id);
                });
                updownfile.down("/api/swyl/v1/salesamplelist/bscSalesSamplelistF/downloadExcel", this.q, "post", 'data');
            },
            //新增销售样表
            createdemand() {
                this.$router.push({path: "/chanp/salesTableFhx"});
            },
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }

    .redclass {
        color: red;
    }
</style>
<style>
    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
    } */
    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }

    .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;

        margin-bottom: 20px;
    }

    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;

    }

    .tanboxs .el-dialog__headerbtn {
        display: none;
    }

    .tanboxs .el-dialog .el-dialog__body {
        padding: 10px;
    }

    .tanboxs .el-dialog {
        box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
        border: 1px solid #ccc;
        border-radius: 10px;
    }

    .tanboxs .el-table thead th {
        padding: 0;
    }

    .tanboxs .el-dialog__header {
        padding: 0;
    }
</style>


